import * as React from "react";
import { useContext } from "react";
import * as Immutable from "immutable";
import { useFormikContext } from "formik";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import BackendWizardContext from "components/authentication/directoryServices/BackendWizard/BackendWizardContext";
import { formHasErrors } from "util/FormsUtils";
import MatchingGroupsContext from "./MatchingGroupsContext";
import { loadMatchingGroups } from "../../api/groupSync";
import prepareLoadGroupsPayload from "../../logic/directoryServices/prepareLoadGroupsPayload";
const _loadGroups = (prepareSubmitPayload, stepsState, setMatchingGroupsContext, currentFormValues, validateForm) => {
  const { formValues, authBackendMeta } = stepsState;
  const wizardFormsValues = { ...formValues, ...currentFormValues };
  const payload = prepareLoadGroupsPayload(
    prepareSubmitPayload,
    wizardFormsValues,
    authBackendMeta.backendId,
    authBackendMeta.serviceType
  );
  setMatchingGroupsContext({ finishedLoading: false, result: void 0 });
  return validateForm({ ...currentFormValues, teamSelection: Immutable.Set([""]) }).then((validationErrors) => {
    if (!formHasErrors(validationErrors)) {
      return loadMatchingGroups(payload).then((loadGroupsResult) => {
        if (loadGroupsResult) {
          setMatchingGroupsContext({ finishedLoading: true, result: loadGroupsResult });
        }
      }).catch((error) => {
        var _a, _b;
        const errors = Immutable.List([error == null ? void 0 : error.message, (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text]);
        setMatchingGroupsContext({ finishedLoading: true, result: { errors } });
      });
    }
    setMatchingGroupsContext({ finishedLoading: true, result: void 0 });
    return null;
  });
};
const _getButtonText = (loadedGroups, teamSelectionType) => {
  if (!loadedGroups || (loadedGroups == null ? void 0 : loadedGroups.size) === 0) return "Load matching groups";
  if (teamSelectionType !== "all") return "Reload matching groups";
  return "Reload matching groups";
};
const LoadMatchingGroupsButton = ({ prepareSubmitPayload, disabled }) => {
  const { result, finishedLoading, setContextValue: setMatchingGroupsContext } = useContext(MatchingGroupsContext);
  const { setStepsState, ...stepsState } = useContext(BackendWizardContext);
  const { values: currentFormValues, validateForm } = useFormikContext();
  const buttonBsStyle = currentFormValues.teamSelectionType !== "all" && !(result == null ? void 0 : result.list) ? "info" : void 0;
  const buttonText = _getButtonText(result == null ? void 0 : result.list, currentFormValues.teamSelectionType);
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: buttonBsStyle,
      disabled,
      onClick: () => _loadGroups(prepareSubmitPayload, stepsState, setMatchingGroupsContext, currentFormValues, validateForm),
      type: "button"
    },
    !finishedLoading ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: buttonText }) : buttonText
  );
};
export default LoadMatchingGroupsButton;
